"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleRecordValueField = void 0;
const market_rule_record_field_1 = require("./market-rule-record-field");
class MarketRuleRecordValueField extends market_rule_record_field_1.MarketRuleRecordField {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.value = obj.value;
        }
    }
    getValue(context) {
        const value = context.evaluateValue(this.value);
        return value;
    }
}
exports.MarketRuleRecordValueField = MarketRuleRecordValueField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtcmVjb3JkLXZhbHVlLWZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS1yZWNvcmQtdmFsdWUtZmllbGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EseUVBQW1FO0FBRW5FLE1BQWEsMEJBQTJCLFNBQVEsZ0RBQXFCO0lBR2pFOzs7T0FHRztJQUNILFlBQW1CLEdBQXlDO1FBQ3hELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQyxLQUFNLENBQUM7UUFDNUIsQ0FBQztJQUNMLENBQUM7SUFFTSxRQUFRLENBQUMsT0FBWTtRQUN4QixNQUFNLEtBQUssR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNoRCxPQUFPLEtBQUssQ0FBQztJQUNqQixDQUFDO0NBQ0o7QUFuQkQsZ0VBbUJDIn0=